import Catalogo from "./Catalogo";

export default Catalogo;
